// ********* CardUserInputModal - modaldownload.jsx ********
// autor: W de Paula / MVinfo
// objetivo: ao final do agendamento via link personalizado, oferecer ao usuário o link pra baixar o app pra android ou pc
// data: 20/7/24 | 20h40
// **************************************************

import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import { Link } from 'react-router-dom';
import imgPlayStore from '../../../../Assets/disponivel/disponivel-android.png';
import imgDesktop from  '../../../../Assets/disponivel/disponivel-pc.png';


const DownloadAppModal = ({ show, onHide, navigateLink }) => {
    const handleClickAndroid = () => {
        alert('android mobile');
    };

    const handleClickDesktop = () => {
        alert('desktop PC');
    };

    

    return (
        <Modal show={show} onHide={onHide}>
            <Modal.Header closeButton>
                <Modal.Title>Facilite seu próximo agendamento!</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p>
                    Baixe o app Agendex pra fazer futuros agendamentos no mesmo estabelecimento, dentre outros, com maior facilidade. 
                    Baixando e abrindo o app agora, você não precisa fazer login todas as vezes que agendar. 
                    No próximo agendamento, basta abrir o app Agendex e fazer o seu agendamento. 
                    São mais de 12 categorias disponíveis.
                </p>
                <div className='android-box text-center'>
                    <Button variant="primary" href="https://play.google.com/store/apps/details?id=br.net.wmx.AgendexCliente&pli=1" style={{ marginRight: '10px' }}>
                        <img src={imgPlayStore} className="android-icone" alt="Disponível Google Play" />
                    </Button>
                </div>
                <div className='android-box text-center'>
                    <Button variant="primary" href="https://drive.google.com/file/d/1vPk7kTQVoUs4I3wcOI7Mc5S6L9J3qe5W/view" style={{ marginRight: '10px' }}>
                        <img src={imgDesktop} className="android-icone" alt="Disponível Google Play" />
                    </Button>
                </div>

            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={() => {
                    onHide();
                    // navigate(navigateLink);
                }}>
                    Continuar
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default DownloadAppModal;